import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  ArrowLeft,
  Star,
  DollarSign,
  CheckCircle,
  XCircle,
  MessageSquare,
  MapPin,
  Calendar,
  Briefcase,
  Clock,
  User,
} from 'lucide-react';
import '../../../../assets/css/screens/customer/dashboard/mybookings/BidDetails.css';
import AppNavbar from '../../../../components/customer/dashboard/apphome/appnavbar/AppNavbar';


const DUMMY_BIDS = [
  {
    id: 1,
    workerName:   'Ali Hassan',
    workerAvatar: 'AH',
    rating:       4.8,
    reviews:      45,
    jobsDone:     132,
    bidAmount:    150,
    message:      'I have 5+ years of experience in plumbing and kitchen renovation. I can complete this job within 2 days with quality materials.',
    deliveryDays: 2,
    status:       'pending',
    postedAgo:    '1 hr ago',
  },
  {
    id: 2,
    workerName:   'James Brown',
    workerAvatar: 'JB',
    rating:       4.5,
    reviews:      28,
    jobsDone:     87,
    bidAmount:    180,
    message:      'Available immediately. I bring all tools and certified materials. Previous kitchen jobs available for reference.',
    deliveryDays: 3,
    status:       'pending',
    postedAgo:    '2 hrs ago',
  },
  {
    id: 3,
    workerName:   'Robert Khan',
    workerAvatar: 'RK',
    rating:       4.2,
    reviews:      17,
    jobsDone:     54,
    bidAmount:    120,
    message:      'Budget-friendly option. I can start tomorrow morning and finish the same day.',
    deliveryDays: 1,
    status:       'pending',
    postedAgo:    '4 hrs ago',
  },
];

const BidDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const job = location.state || {
    title:       'Kitchen Renovation Help',
    serviceType: 'Plumbing',
    budget:      '$200',
    city:        'Petersburg',
    deadline:    '2026-04-10',
    postedAt:    'Mar 24, 2026',
    status:      'Open',
    bidsCount:   DUMMY_BIDS.length,
  };

  const [bids, setBids] = useState(DUMMY_BIDS);
 console.log(location.state);
  // ── Accept bid ───────────────────────────────────────────
  const handleAccept = (bidId) => {
    const acceptedBid = bids.find(b => b.id === bidId);
    if (!acceptedBid) return;

    // 1. Mark bid as accepted in UI
    setBids(prev =>
      prev.map(b =>
        b.id === bidId
          ? { ...b, status: 'accepted' }
          : { ...b, status: b.status === 'accepted' ? 'pending' : b.status }
      )
    );

    // 2. Build new booking object
    const newBooking = {
      id:             `bid_${bidId}_${Date.now()}`,
      service:        job.title,
      provider:       acceptedBid.workerName,
      date:           job.deadline || '2026-04-10',
      time:           '10:00 AM',
      address:        job.city || 'N/A',
      price:          `$${acceptedBid.bidAmount}`,
      platformFee:    '$5',
      status:         'Confirmed',
      providerRating: acceptedBid.rating,
      providerIcon:   '🔧',
      tab:            'upcoming',
      providerPhone:  'N/A',
    };

    // 3. Save to localStorage → acceptedBookings
    const existing = JSON.parse(localStorage.getItem('acceptedBookings') || '[]');
    // avoid duplicate
    const alreadyExists = existing.find(b => b.id === newBooking.id);
    if (!alreadyExists) {
      localStorage.setItem('acceptedBookings', JSON.stringify([...existing, newBooking]));
    }

    // 4. Remove this job from postedJobs in localStorage
    const postedJobs = JSON.parse(localStorage.getItem('postedJobs') || '[]');
    const updatedJobs = postedJobs.filter(j => j.id !== job.id);
    localStorage.setItem('postedJobs', JSON.stringify(updatedJobs));
  };

  // ── Reject bid ───────────────────────────────────────────
  const handleReject = (bidId) => {
    setBids(prev =>
      prev.map(b => b.id === bidId ? { ...b, status: 'rejected' } : b)
    );
  };

  // ── Chat ─────────────────────────────────────────────────
  const handleChat = (bid) => {
    navigate(`/chat/${bid.id}`, { state: bid });
  };

  const acceptedBid = bids.find(b => b.status === 'accepted');

  return (
    <>
      <AppNavbar />
      <div className="pjb-page">

        {/* HEADER */}
        <div className="pjb-header">
          <button className="pjb-back-btn" onClick={() => navigate(-1)}>
            <ArrowLeft size={22} />
          </button>
          <h2 className="pjb-title">Bids Received</h2>
          {acceptedBid && (
            <span className="pjb-assigned-badge">
              <CheckCircle size={13} /> Assigned
            </span>
          )}
        </div>

        <div className="pjb-content">

          {/* JOB SUMMARY CARD */}
          <div className="pjb-job-card">
            <div className="pjb-job-top">
              <div>
                <h2 className="pjb-job-title">{job.title}</h2>
                <span className="pjb-job-type">
                  <Briefcase size={12} /> {job.serviceType}
                </span>
              </div>
              <span className={`pjb-job-status pjb-job-status--${(job.status || 'open').toLowerCase()}`}>
                {job.status || 'Open'}
              </span>
            </div>
            <div className="pjb-job-meta">
              {job.city && (
                <span className="pjb-job-meta-item">
                  <MapPin size={13} /> {job.city}
                </span>
              )}
              {job.deadline && (
                <span className="pjb-job-meta-item">
                  <Calendar size={13} /> Deadline: {job.deadline}
                </span>
              )}
              <span className="pjb-job-meta-item">
                <DollarSign size={13} /> Budget: {job.budget}
              </span>
              <span className="pjb-job-meta-item">
                <Clock size={13} /> Posted: {job.postedAt}
              </span>
            </div>
            <div className="pjb-bids-count">
              <User size={14} />
              {bids.filter(b => b.status !== 'rejected').length} bid{bids.length !== 1 ? 's' : ''} received
            </div>
          </div>

          {/* BIDS LIST */}
          {bids.length === 0 ? (
            <div className="pjb-empty">
              <Briefcase size={44} className="pjb-empty-icon" />
              <p className="pjb-empty-text">No bids received yet.</p>
              <p className="pjb-empty-sub">Workers will start bidding on your job soon.</p>
            </div>
          ) : (
            <div className="pjb-bids-list">
              {bids.map((bid, index) => (
                <div
                  key={bid.id}
                  className={`pjb-bid-card${bid.status === 'accepted' ? ' pjb-bid-card--accepted' : ''}${bid.status === 'rejected' ? ' pjb-bid-card--rejected' : ''}`}
                  style={{ animationDelay: `${index * 0.07}s` }}
                >
                  {/* Worker Info Row */}
                  <div className="pjb-worker-row">
                    <div className="pjb-avatar">{bid.workerAvatar}</div>
                    <div className="pjb-worker-info">
                      <div className="pjb-worker-name-row">
                        <span className="pjb-worker-name">{bid.workerName}</span>
                        {bid.status === 'accepted' && (
                          <span className="pjb-accepted-tag">
                            <CheckCircle size={11} /> Accepted
                          </span>
                        )}
                        {bid.status === 'rejected' && (
                          <span className="pjb-rejected-tag">
                            <XCircle size={11} /> Rejected
                          </span>
                        )}
                      </div>
                      <div className="pjb-worker-stats">
                        <span className="pjb-rating">
                          <Star size={12} className="pjb-star" />
                          {bid.rating}
                          <span className="pjb-reviews">({bid.reviews})</span>
                        </span>
                        <span className="pjb-divider">·</span>
                        <span className="pjb-jobs-done">{bid.jobsDone} jobs</span>
                      </div>
                    </div>
                    <div className="pjb-bid-amount-wrap">
                      <span className="pjb-bid-amount">${bid.bidAmount}</span>
                      <span className="pjb-bid-days">{bid.deliveryDays}d delivery</span>
                    </div>
                  </div>

                  {/* Bid Message */}
                  <p className="pjb-bid-message">{bid.message}</p>

                  {/* Time */}
                  <span className="pjb-bid-time">
                    <Clock size={11} /> {bid.postedAgo}
                  </span>

                  {/* Action Buttons */}
                  {bid.status === 'pending' && (
                    <div className="pjb-bid-actions">
                      <button
                        className="pjb-btn pjb-btn--accept"
                        onClick={() => handleAccept(bid.id)}
                      >
                        <CheckCircle size={15} /> Accept Bid
                      </button>
                      <button
                        className="pjb-btn pjb-btn--chat"
                        onClick={() => handleChat(bid)}
                      >
                        <MessageSquare size={15} /> Chat
                      </button>
                      <button
                        className="pjb-btn pjb-btn--reject"
                        onClick={() => handleReject(bid.id)}
                      >
                        <XCircle size={15} /> Reject
                      </button>
                    </div>
                  )}

                  {bid.status === 'accepted' && (
                    <div className="pjb-bid-actions">
                      <button
                        className="pjb-btn pjb-btn--chat"
                        onClick={() => handleChat(bid)}
                      >
                        <MessageSquare size={15} /> Chat with Worker
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}

        </div>
      </div>
    </>
  );
};

export default BidDetails;